export const SDK_TYPE = 'HeidelpayNodeJS'
export const SDK_VERSION = '1.3.1'